import {
  faCheck,
  faFileLines,
  faUniversalAccess,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListItem from "./index";

function TextbookListItem({ data, ...props }) {
  const publisher =
    data.contributors['relator/pbl']?.join(", ") ?? data.meta.publisher ?? null;

  return (
    <ListItem
      {...props}
      itemId={data.id}
      href={`/textbook/${data.code}/`}
      aria-label={`${data.title}${data.meta.subtitle ? `: ${data.meta.subtitle}` : ""}${data.meta.edition ? `, ${data.meta.edition}` : ""} textbook`}
      aria-describedby={`bccampus-textbook-publisher-${data.id} bccampus-list-item-meta-${data.id}`}
      coverImage={data.image}
      title={data.name}
      subtitle={data.meta.subtitle}
      extra={
        <>
          {!!data.meta.edition && data.meta.edition}
          {!!publisher && !!data.meta.edition && " | "}
          {!!publisher && (
            <span
              id={`bccampus-textbook-publisher-${data.id}`}
              aria-label={`, published by ${publisher}`}
            >
              {publisher}
            </span>
          )}
        </>
      }
      meta={
        <>
          {data.meta.isAdopted && (
            <span className="bccampus-tag" aria-label=", adopted">
              <FontAwesomeIcon icon={faUser} />
              Adopted
            </span>
          )}
          {data.hasSupportingResources && (
            <span
              className="bccampus-tag"
              aria-label=", has supplemental files"
            >
              <FontAwesomeIcon icon={faFileLines} />
              Supplemental
            </span>
          )}
          {data.meta.isAccessible && (
            <span className="bccampus-tag" aria-label=", accessible">
              <FontAwesomeIcon icon={faUniversalAccess} />
              Accessible
            </span>
          )}
          {data.meta.isReviewed && (
            <span className="bccampus-tag" aria-label=", reviewed">
              <FontAwesomeIcon icon={faCheck} />
              Reviewed
            </span>
          )}
        </>
      }
    />
  );
}

export default TextbookListItem;
